import { useContext } from 'react';
import { OrderTypes } from '../../../common/enums/enums';
import { ApprovalsContext } from '../Approvals.provider';

export const getServicesPendingToApprove = order =>
  order?.relatedOrders
    .filter(
      relatedOrder => relatedOrder.orderType !== OrderTypes.RECONDITIONING
    )
    .map(relatedOrder => relatedOrder.services)
    .flat()
    .filter(service => !service.declinedAt && !service.approvedAt) || [];

export default function useStatusByOrder(order) {
  const {
    servicesCheckedStatus,
    markServiceAsApproved,
    markServiceAsDeclined,
    setOrderToApproveOrDecline,
  } = useContext(ApprovalsContext);

  const enableConfirmation = getServicesPendingToApprove(order).every(
    service => servicesCheckedStatus[service.vendorOrderServiceId]
  );

  const markAllAsApproved = () => {
    getServicesPendingToApprove(order).forEach(service => {
      markServiceAsApproved(service.vendorOrderServiceId);
    });
    setOrderToApproveOrDecline(order);
  };

  const markAllAsDeclined = () => {
    getServicesPendingToApprove(order).forEach(service => {
      markServiceAsDeclined(service.vendorOrderServiceId);
    });
    setOrderToApproveOrDecline(order);
  };

  return { enableConfirmation, markAllAsApproved, markAllAsDeclined };
}
